module.exports = __webpack_public_path__ + "static/img/footer-code2.b51c53b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/footer-code2.jpg
// module id = rqtc
// module chunks = 22